import { IFindCallerObject } from '@vfit/shared/models';

export const DEFAULT_FIND_CALLER: IFindCallerObject = {
  activeSimMobile: false,
  individualRef: {
    msisdn: '',
    email: '',
  },
  selectedContactMedium: {
    field: '',
    fieldType: '',
  },
  showOtp: false,
  verifyOtp: '',
  customerHasActiveSubs: false,
};

export const DEFAULT_PRODUCT = {};

export const DEFAULT_SLIDES_GO_BACK = -1;

export const DEFAULT_LAST_CARD = false;
